import React, { useState, useEffect, Fragment } from "react";
import { Alert } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Axios from "./apiClient/instance/Axios";
import Preloader from "./components/UI/Preloader";
import NavRoutes from "./routes";
import * as AuthActions from "./store/auth/actions";
import * as ConfigActions from "./store/config/actions";
import { useLocation, useSearchParams } from 'react-router-dom';
import { cookieStore } from 'cookie-store';

function App() {
  const [isFetching, setIsFetching] = useState(false);
  const { showAlert, alertMessage } = useSelector((state) => state.config);
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams()

  const handleFetchSession = async () => {
    if(!!searchParams.get("auth_tok")){
      try {
        Axios.defaults.headers["Authorization"] = `jwt ${searchParams.get("auth_tok")}`;
        setIsFetching(true);
        dispatch(AuthActions.UserSession());
        setTimeout(() => {
          setIsFetching(false);
        }, 500);
      } catch (error) {
        console.error("Error while fetching session: ", error);
      } finally {
        setTimeout(() => {
          setIsFetching(false);
        }, 500);
      }
    }
    else{

      try {
        cookieStore.get("cerebry-jwt-token").then((e)=>{
          if(e==null){
            if (!localStorage.getItem("jwt")) return;
            setIsFetching(true);
            dispatch(AuthActions.UserSession());
          }
          else{
            Axios.defaults.headers["Authorization"] = `jwt ${e.value}`;
            setIsFetching(true);
            dispatch(AuthActions.UserSession());
          }
          setTimeout(() => {
            setIsFetching(false);
          }, 500);
        }).catch((err)=>{
          console.log("Error while fetching session: ",err)
        })
      } catch (error) {
        console.error("Error while fetching session: ", error);
      } finally {
        setTimeout(() => {
          setIsFetching(false);
        }, 500);
      }
    }

    if(!!searchParams.get("class_code")){
      sessionStorage.setItem("class_code",searchParams.get("class_code"))
    }
  };

  const handleCloseAlert = () => {
    dispatch(ConfigActions.showAlertInit());
  };

  useEffect(() => {
    handleFetchSession();
  }, []);

  return (
    <>
      {
        !isFetching?
        <Fragment>
          {showAlert && (
            <Alert
              variant="danger"
              onClose={handleCloseAlert}
              dismissible
              style={{
                position: "absolute",
                zIndex: "2000",
                right: "10px",
                top: "20px",
              }}
            >
              <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
              <p className="text-danger">{alertMessage}</p>
            </Alert>
          )}
          <NavRoutes />
        </Fragment>
        :
        <Preloader />
      }
    </>
  );
}

export default App;
